import React from "react";
import SimpleReactValidator from "simple-react-validator";
import Contact from "./Contact";
import User from "./User";

class AddEditUserForm extends React.Component {
    constructor(props) {
        super(props);
        this.valitdatorList = new SimpleReactValidator();
        this.state = {
            ...this.props.contactProp,
            contactObject: this.props.contactObject,
            submitted: false,
            formType: this.props.formTypePro || "",
            checked: true
        };
        this.handleSubmitForm = this.handleSubmitForm.bind(this);
    }

    handleSubmitForm(e) {
        e.preventDefault();
        if (this.valitdatorList.allValid()) {
            this.setState(
                {
                    submitted: true
                },
                function () {
                    this.props.handleFormSubmitProp(this.state.contactObject);
                }
            );
        } else {
            this.setState({ submitted: false });
            this.valitdatorList.showMessages();
            this.forceUpdate();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.checked !== prevState.checked) {
            this.props.returnState({
                createUserChecked: this.state.checked
            });
        }
    }

    render() {
        return (
            <form onSubmit={this.handleSubmitForm}>
                <div className="flexElem addCustomer">
                    <User
                        requiredField={{
                            user_name: "required",
                            password: "required",
                            password_confirmation: "required",
                            role_id: "required"
                        }}
                        htmlElement={"user"}
                        returnState={this.props.returnState}
                        validatorInstance={this.props.validatorProp}
                        contactProp={this.props.contactProp}
                        rolesProp={this.props.rolesProp}
                    />
                </div>
                <div className="row">
                    <br />
                </div>
                <div className="row">
                    <div className="col-md-12 mb-xlg">
                        <div className="mt-xlg text-center">
                            <input
                                type="submit"
                                value="Submit"
                                className="customBtn btnBlue"
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default AddEditUserForm;



// WEBPACK FOOTER //
// ./src/components/ThemeComponents/AddEditUserForm.jsx